/** Chapter map pin colors (must match peo-hub-go/internal/features/maps/constants.go). */
export const MAP_PIN_COLOR = {
  active: '#0072CE',
  disbanded: '#D2042D',
  merged: '#000000',
  mixed: '#7E57C2',
} as const;

export const CHAPTER_MAP_TYPE_ID = 'chapters';
